import React from 'react';

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
  maximumFractionDigits: 2,
});

export const formatVal = (type, val, trunc = null) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
  if (val === null) {
    return val;
  }
  if (trunc === "trunc") {
    switch (type) {
      case "Currency":
        return Math.round(val);

      case "Integer":
        return Math.round(val);
      case "Decimal":
        return val ? Number(val.toFixed(2)) : val;
      case "Percentage":
        return Number(val);
      case "Decimal_With_Percentage":
        var roundedNumber = Math.round(val * 100) / 100;
        return roundedNumber;

      default:
        return type;
    }
  } else {
    switch (type) {
      case "Currency":
        // return val >0?  `$${formatPrice(parseInt(val))}` : `-$${formatPrice(Math.abs(parseInt(val)))}
        // return `${formatter.format(parseInt(val))}`;
        return `${formatter.format(Math.round(val))}`;
      case "Integer":
        return `${Math.round(val).toLocaleString()}`;
      case "Percentage":
        // return `${parseInt(val)}%`;
        return `${Math.round (val)}%`;
      case "Decimal_With_Percentage":
        // Round up to 2 decimal places, preserving sign for negative values
        return `${(Math.sign(val) * Math.ceil(Math.abs(val) * 100) / 100).toFixed(2)}%`;
      case "Decimal":
        return `${+val ? (+val).toFixed(2) : +val}`;
      default:
        return type;
    }
  }
};

export const formatPrice = (price) => {
  return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const CalculateTypeWithUpperCaseSuffix = (value) => {
  if (!value) {
    return ["00.0", ""];
  } else if (value > 0 && value < 1000) {
    return [`${value.toFixed(2)}`, ``];
  } else if (value >= 1000 && value < 1000000) {
    return [`${(value / 1000).toFixed(2)}`, `K`];
  } else if (value >= 1000000 && value < 1000000000) {
    return [`${(value / 1000000).toFixed(2)}`, `M`];
  } else if (value >= 1000000000 && value < 1000000000000) {
    return [`${(value / 1000000000).toFixed(2)}`, `B`];
  } else if (value >= 1000000000000) {
    return [`${(value / 1000000000000).toFixed(2)}`, `T`];
  } else {
    return [`${value.toFixed(2)}`, ``];
  }
};

export const CalculateType = (value) => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (!value || typeof numValue !== 'number' || isNaN(numValue)) {
    return ["00.0", ""];
  } else if (value > 0 && value < 1000) {
    return [`${value.toFixed(2)}`, ``];
  } else if (value >= 1000 && value < 1000000) {
    return [`${(value / 1000).toFixed(2)}`, `k`];
  } else if (value >= 1000000 && value < 1000000000) {
    return [`${(value / 1000000).toFixed(2)}`, `m`];
  } else if (value >= 1000000000 && value < 1000000000000) {
    return [`${(value / 1000000000).toFixed(2)}`, `b`];
  } else if (value >= 1000000000000) {
    return [`${(value / 1000000000000).toFixed(2)}`, `t`];
  } else {
    return [`${value.toFixed(2)}`, ``];
  }
};

export const formatCSVData = (dealerData, tableColumns, viewType = null) => {
  const convertedData = dealerData.map((item, i) => {
    let obj = {};
    // Only add Jump ID for rooftop and dealer views, not for group view
    if (viewType !== "group") {
      obj["JUMPID"] = item["DealerID"] || "N/A";
    }

    // Add CaseSafeID based on viewType
    if (viewType === "rooftop") {
      obj["CaseSafeID"] = (item["CaseSafeIDs"] && item["CaseSafeIDs"].length > 0) ? item["CaseSafeIDs"] : ["N/A"];
    } else if (viewType === "dealer") {
      obj["CaseSafeID"] = item["CaseSafeID"] || "N/A";
    }
    tableColumns?.forEach((col) => {
      let alias = col.alias;
      if (alias === "Avg Mo Revenue") {
        alias = "Avg Mo Revenue($)";
      }
      if (alias === "Valuation (Low)") {
        alias = "Valuation (Low)($)";
      }
      if (alias === "Valuation (High)") {
        alias = "Valuation (High)($)";
      }
      if (alias === "PVR") {
        alias = "PVR($)";
      }
      if (alias === "F&I") {
        alias = "F&I($)";
      }

      const { dataIndex, type } = col;

      if (alias === "ZIP") {
        obj[alias] = `\t${String(item[dataIndex])}`;
      } else if (dataIndex === "FactorDetails") {
        const { factorId, factType } = col;

          // Validate FactorDetails and factorId
          if (!item[dataIndex] || typeof item[dataIndex] !== "object") {
            obj[alias] = "N/A"; // Default value for invalid data
            return;
          }
  
          if (!item[dataIndex].hasOwnProperty(factorId)) {
            obj[alias] = "N/A"; // Default value for missing factorId
            return;
          }

        let formattedValue = formatVal(factType, item[dataIndex][factorId]);

        // Remove the $ sign if the type is currency and it's used in CSV
        if (factType === "Currency") {
          formattedValue = formattedValue
            ?.replace(/^\$/, "")
            ?.replace(/-\$/, "-");
        }
        if (alias === "Avg Mo Revenue($)") {
          formattedValue = Math.round(item[dataIndex][factorId]);
        }
        obj[alias] = formattedValue;

        // if (factorId == "120") {
        //   obj[alias] = `$${CalculateType(item[dataIndex][factorId]).join("")}`;
        // } else {
        //   obj[alias] = formatVal(factType, item[dataIndex][factorId]);
        // }
      } else {
        if (type === "decimal")
          obj[alias] = formatVal("Decimal", item[dataIndex]);
        else if (type === "currency") obj[alias] = Math.round(item[dataIndex]);
        // obj[alias] = `$${CalculateType(item[dataIndex]).join("")}`;
        else obj[alias] = item[dataIndex];
      }
      if (alias === "Units Sold(%)" || alias === "Units Sold") {
        obj[alias] = item[dataIndex]?.toFixed(2);
      }
    });
    
    // Preserve original Performance/Environment/Opportunity/Value from raw data for chart compatibility
    // This must be done AFTER tableColumns processing to avoid being overwritten by "N/A"
    if (item.Performance !== undefined && item.Performance !== null) {
      obj["Performance"] = item.Performance;
    }
    if (item.Environment !== undefined && item.Environment !== null) {
      obj["Environment"] = item.Environment;
    }
    if (item.Opportunity !== undefined && item.Opportunity !== null) {
      obj["Opportunity"] = item.Opportunity;
    }
    if (item.Value !== undefined && item.Value !== null) {
      obj["Value"] = item.Value;
    }
    
    return obj;
  });

  return convertedData;
};

export const calculateScore = (
    values,
    weights,
    perfEnvRange,
    type = "performance",
    primaryBrand,
    new_used_abs_max_list,
    selectedRegion,
    state_nu_sb_abs_list,
    national_nu_sb_abs_list
  ) => {
    
    const sections = {
      'Luxury': ['PORSCHE', 'MERCEDES-BENZ','MERCEDES BENZ' ,'LEXUS', 'BMW', 'AUDI', 'JAGUAR', 'LAND ROVER', 'VOLVO', 'ACURA', 'CADILLAC', 'LINCOLN', 'INFINITI', 'GENESIS', 'ALFA ROMEO', 'MASERATI', 'LAMBORGHINI', 'FERRARI', 'LOTUS', 'ASTON MARTIN', 'BENTLEY', 'ROLLS ROYCE', 'MCLAREN'],
      'Domestic': ['CHEVROLET', 'FORD', 'BUICK', 'GMC', 'CHRYSLER', 'DODGE', 'JEEP', 'RAM'],
      'Import': ['TOYOTA', 'HONDA', 'SUBARU', 'HYUNDAI', 'KIA', 'VOLKSWAGEN', 'MAZDA', 'NISSAN', 'MITSUBISHI', 'MINI', 'FIAT', 'SMARTCAR'],
    };
    
    let brand_type = null;
    primaryBrand=primaryBrand?.toUpperCase()
    
    if (sections["Luxury"].includes(primaryBrand)) {
      brand_type = "Luxury";
    } else if (sections["Domestic"].includes(primaryBrand)) {
      brand_type = "Domestic";
    } else if (sections["Import"].includes(primaryBrand)) {
      brand_type = "Import";
    }
    
    const brand_specific_values = {
      "Luxury": { "Median Household Income": 4 },
      "Domestic": { "Median Household Income": 1 },
      "Import": { "Median Household Income": -4 },
    };
    
    let median_household_weight = 0;
    
    if (brand_type && brand_specific_values[brand_type]) {
      median_household_weight = brand_specific_values[brand_type]["Median Household Income"];
    }
    if ("Median Household Income" in weights) {
      weights["Median Household Income"] = median_household_weight;
    }
  
    let prange = 1;
    let invPsensitivity = 3;
    const pscoreLow = 60,
      pscoreHigh = 100;
    const pscoreRange = pscoreHigh - pscoreLow;
    const pscoreMean = (pscoreHigh + pscoreLow) / 2;

    if (type === "environment") {
      prange = 0.5;
      invPsensitivity = 2;
    }

    const factors = Object.keys(values);

    factors.forEach((factor) => {
      if (values[factor]) {
        let { value, low, high } = values[factor];
        // Skip clamping if value is 0
        if (value === 0) {
          values[factor].value = value;
        } else {
          values[factor].value = Math.max(low, Math.min(high, value));
        }
      }
    });

    let weightedScores = [];
    factors.forEach((factor) => {
      if (values[factor] && weights[factor] !== undefined) {
       
    
        const { value, low, high } = values[factor];
        const factorRange = high - low;
        const factorMean = (high + low) / 2;
        
        let stdScore =
          factorRange !== 0 ? (value - factorMean) / factorRange : 0;

          if (factor === "New to Used Ratio") {
            // Select the appropriate list based on the selectedRegion
            let listToUse;
            if (selectedRegion === 'state') {
              listToUse = state_nu_sb_abs_list;
            } else if (selectedRegion === 'national') {
              listToUse = national_nu_sb_abs_list;
            } else {
              listToUse = new_used_abs_max_list;
            }
            
            // Filter out null, undefined, and non-numeric values
            const cleanedList = listToUse.filter(
              (val) => val !== null && val !== undefined && typeof val === "number"
            );
          
            // Find the maximum value, ignoring empty or all-zero cases
            const denom = Math.max(...cleanedList);
          
            // Use 0 if value is null or undefined
            let value = values[factor].value ?? 0;
          
            if (!cleanedList.length || denom === 0) {
              stdScore = 0;
            } else {
              stdScore = 0.5 - Math.abs(value - 1) / denom;
            }
          }

        const weightedScore = stdScore * weights[factor];
        weightedScores.push(weightedScore);
      }
    });
    
    let totalScore = 0;

    for (let i = 0; i < weightedScores.length; i++) {
      totalScore += weightedScores[i];
    }

    const performanceWstd = weightedScores.reduce((sum, score) => sum + score, 0);
    const adjustedPerformance = performanceWstd / invPsensitivity;
    
    // Use region-specific ranges based on selectedRegion
    let scoreLow, scoreHigh;
    
    if (selectedRegion === 'state') {
      scoreLow = type === "performance"
        ? perfEnvRange?.performance_low_state
        : perfEnvRange?.environment_low_state;
      scoreHigh = type === "performance"
        ? perfEnvRange?.performance_high_state
        : perfEnvRange?.environment_high_state;
    } else if (selectedRegion === 'national') {
      scoreLow = type === "performance"
        ? perfEnvRange?.performance_low_national
        : perfEnvRange?.environment_low_national;
      scoreHigh = type === "performance"
        ? perfEnvRange?.performance_high_national
        : perfEnvRange?.environment_high_national;
    } else {
      // Default/fallback to original values
      scoreLow = type === "performance"
        ? perfEnvRange?.performance_low
        : perfEnvRange?.environment_low;
      scoreHigh = type === "performance"
        ? perfEnvRange?.performance_high
        : perfEnvRange?.environment_high;
    }    

    if (adjustedPerformance > scoreHigh)
      scoreHigh = adjustedPerformance;
    if (adjustedPerformance < scoreLow)
      scoreLow = adjustedPerformance;
     
    const normalizedScore =
      ((adjustedPerformance - scoreLow) / (scoreHigh - scoreLow)) * prange -
      prange / 2;


    let finalScore = (normalizedScore / prange) * pscoreRange + pscoreMean;

    return Math.max(60, Math.min(100, finalScore));
  };

// ({
//   Name: item.DealerName,
//   Brand: item.Brand,
//   Group: item.GroupName,
//   City: item.City,
//   State: item.StateCode,
//   "Avg Revenue TTM":
//     item.FactorDetails["120"] &&
//     `$${CalculateType(item.FactorDetails["120"]).join("")}`,
//   ZIP: item.ZipCode,
//   "Valuation(Low)": `$${CalculateType(item.LowRange).join("")}`,
//   "Valuation(High)": `$${CalculateType(item.HighRange).join("")}`,
//   // "Val $": `$${CalculateType(item.Valuation).join("")}`,
//   "Dealer Multiple": formatVal("Decimal", item.DealerAvgMultiple),
//   "State Brand Multiple": formatVal("Decimal", item.SBMultiple),
//   Performance: formatVal("Decimal", item.Performance),
//   PVR: formatVal("Currency", item.FactorDetails?.["7"]),
//   "F&I": formatVal("Currency", item.FactorDetails?.["2"]),
//   "New / Used": formatVal("Decimal", item.FactorDetails?.["90"]),
// })

// Helper function to check access for restricted features (Market Share, Real Estate Report)
export const checkRestrictedFeatureAccess = (username) => {
  if (!username) return false;
  
  const lowerUsername = username.toLowerCase();
  
  // Check if user is mohit
  if (lowerUsername === "mohit") return true;
  
  // Check if user is test1 through test10
  for (let i = 1; i <= 10; i++) {
    if (lowerUsername === `test${i}`) return true;
  }
  
  return false;
};

// Format search parameters for tooltip display in portfolio components
export const formatSearchTooltip = (searchData) => {
  if (!searchData || !searchData.PreviousSearchValues) return null;

  const searchType = searchData.SearchType;
  const values = searchData.PreviousSearchValues;
  
  let tooltipContent = [];
  tooltipContent.push({ fieldName: "Type", displayValue: searchType });
  
  // Field name mapping for better display
  const fieldNameMap = {
    1: "Zip Code/Dealership",
    2: "Revenue Range", 
    3: "State",
    4: "Brand",
    5: "Radius",
    6: "Revenue Range",
    7: "Dealership Group",
    9: "Brand"
  };
  
  Object.values(values).forEach(param => {
    if (!param.Value || param.Value === "[]" || param.Value === "{\"low\":null,\"high\":null}") return;
    
    let displayValue = param.Value;
    let fieldName = param.Field_Name || fieldNameMap[param.search_field_config_id] || `Field ${param.search_field_config_id}`;
    
    // Remove asterisk signs from field names
    if (fieldName) {
      fieldName = fieldName.replace(/\*/g, '').trim();
    }
    
      // Handle different value formats
      try {
        // Check if Value is already an array (like dealership groups)
        if (Array.isArray(param.Value)) {
          if (param.Value.length > 3) {
            displayValue = param.Value.slice(0, 3).join(', ') + '...';
          } else {
            displayValue = param.Value.join(', ');
          }
        } else if (param.Value.startsWith('[') || param.Value.startsWith('{')) {
          const parsed = JSON.parse(param.Value);
          if (Array.isArray(parsed) && parsed.length > 0) {
            // Show only first 3 items and add "..." if there are more
            if (parsed.length > 3) {
              displayValue = parsed.slice(0, 3).join(', ') + '...';
            } else {
              displayValue = parsed.join(', ');
            }
          } else if (parsed.low !== null || parsed.high !== null) {
            displayValue = `${parsed.low || 'Min'} - ${parsed.high || 'Max'}`;
          }
        } else if (param.Value.includes(',') || param.Value.includes(';') || param.Value.includes('|')) {
          // Handle comma-separated, semicolon-separated, or pipe-separated values
          const separator = param.Value.includes(',') ? ',' : param.Value.includes(';') ? ';' : '|';
          const values = param.Value.split(separator).map(v => v.trim()).filter(v => v);
          if (values.length > 3) {
            displayValue = values.slice(0, 3).join(', ') + '...';
          } else {
            displayValue = values.join(', ');
          }
        }
      } catch (e) {
        // Keep original value if parsing fails
      }
    
    if (displayValue && displayValue !== "[]") {
      tooltipContent.push({ fieldName, displayValue });
    }
  });
  
  return tooltipContent.length > 1 ? (
    <div className="portfolio-search-tooltip">
      {tooltipContent.map((item, index) => (
        <div key={index} className={`portfolio-tooltip-item ${index === 0 ? 'portfolio-tooltip-first-item' : ''}`}>
          <span className="portfolio-tooltip-field-name">{item.fieldName}: </span>
          <span className="portfolio-tooltip-field-value">{item.displayValue}</span>
        </div>
      ))}
    </div>
  ) : null;
};
